import {
  JitsiMeetJS,
  MEDIA_TYPE,
  useTrackByParticipantId,
} from '@cometchat/calls-sdk-core';
import { memo, useCallback, useEffect, useRef } from 'react';
import './wave.css';

interface WaveProps {
  pid: string;
}

export const Wave = memo(({ pid }: WaveProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const rectsRef = useRef<(HTMLDivElement | null)[]>([]);
  const track = useTrackByParticipantId(pid, MEDIA_TYPE.AUDIO)?.originalTrack;

  console.log('Feb 19, 2026 rerender');

  const setListener = useCallback((e: number) => {
    const scaleValue = Math.max(100, Math.min(1200 * e, 200));

    if (containerRef.current) {
      containerRef.current.style.setProperty('--wave-scale', `${scaleValue}%`);
    }

    if (scaleValue <= 100) {
      rectsRef.current.forEach(rect => {
        if (rect) rect.style.transform = 'scaleY(1)';
      });
    } else {
      const randomScales = [
        1 + Math.random(),
        1 + Math.random() * 1.5,
        1 + Math.random(),
      ];
      rectsRef.current.forEach((rect, i) => {
        if (rect) {
          rect.style.transform = `scaleY(calc(var(--wave-scale) * ${randomScales[i]}))`;
        }
      });
    }
  }, []);

  useEffect(() => {
    track?.on(JitsiMeetJS.events.track.TRACK_AUDIO_LEVEL_CHANGED, setListener);
    return () => {
      track?.off(
        JitsiMeetJS.events.track.TRACK_AUDIO_LEVEL_CHANGED,
        setListener,
      );
    };
  }, [setListener, track]);

  return (
    <div ref={containerRef} className="cometchat-calls-wave-container">
      <div
        ref={el => {
          rectsRef.current[0] = el;
        }}
        className="cometchat-calls-wave-rect"
      />
      <div
        ref={el => {
          rectsRef.current[1] = el;
        }}
        className="cometchat-calls-wave-rect"
      />
      <div
        ref={el => {
          rectsRef.current[2] = el;
        }}
        className="cometchat-calls-wave-rect"
      />
    </div>
  );
});
